import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type PlatformOperatorStatsListResponse = {
  idleOps: PlatformOperatorResponse[]
  offlineOps: PlatformOperatorResponse[]
  readyOps: PlatformOperatorResponse[]
  taskedOps: PlatformOperatorResponse[]
}

type PlatformOperatorResponse = {
  name: string | null
  avatar_url: string
  app_user_id: string
  state: string
  role: string
  eligible_program_ids: string[]
}

export function useSkyView() {
  return useQuery<PlatformOperatorStatsListResponse>({
    queryKey: ['platform-operator-stats-list'],
    queryFn: async () => {
      const { data } = await apiClient.get(`/int/dispatcher2/skyview`)
      return data
    },
  })
}
